<style lang="scss" scoped>
$klz-red: #c50c0e;
.container {
  .row {
    margin: 10px 0;
  }
  input,
  textarea {
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc;
    &:focus {
      border: 1px solid $klz-red;
    }
  }
  .btn-all {
    border: 0;
    background: none;
    background: #eee;
    padding: 10px 15px;
    margin-top: 10px;
    text-transform: uppercase;
    font-size: 80%;
    letter-spacing: 1px;
    @media (max-width: 768px) {
      width: 100%;
      display: block;
    }
    &:hover {
      background: $klz-red;
      color: #fff;
    }
  }
}

.profile {
  .top-section {
    display: none;
  }
  .profil-header {
    background: #f9f9f9;
    padding: 20px 0;
    h1 {
    }
    p {
      margin: 0;
      font-style: italic;
    }
  }

  .headline-data {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 130%;
    margin-bottom: 10px;
    &:after {
      content: '';
      display: block;
      width: 7%;
      margin: 10px 0;
      height: 3px;
      background: #eee;
      @media (max-width: 768px) {
        width: 10%;
      }
    }
  }

  .text {
    margin-bottom: 30px;
  }

  .data-container {
    margin-top: 40px;
    @media (max-width: 768px) {
      margin-top: 20px;
    }
  }

  .imagepreview {
    text-align: center;
    img {
      max-height: 100px;
      max-width: 100%;
      width: auto;
    }
  }
}
</style>

<template>
  <div class="profile">
    <Header />
    <!-- showDescription = Soll der Text anzeigt werden ("Hier finden sie eine Auswahl...") -->
    <div class="profil-header">
      <b-container>
        <b-row>
          <b-col>
            <h1 v-if="!success">Jetzt eintragen!</h1>
            <h1 v-if="success">Vielen Dank für Ihre Eintragung!</h1>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container class="data-container" v-if="!success">
      <b-row>
        <b-col class="headline-data">
          Firmen Daten
        </b-col>
      </b-row>
      <b-row class="text">
        <b-col>
          Tragen Sie hier die Daten Ihres Unternehmens ein.
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          Name*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.firma" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Beschreibung: </b-col>
        <b-col lg="8" md="12">
          <textarea v-model="unternehmen.beschreibungprodukt"></textarea>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Branche*: </b-col>
        <b-col lg="8" md="12">
          <DropDown :options="branchen" :value="unternehmen.branche" @input="setBranche"></DropDown>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Website: </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.website" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Email: </b-col>
        <b-col lg="8" md="12">
          <input type="email" v-model="unternehmen.email" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">Telefon-Nummer: </b-col>
        <b-col lg="8" md="12"><input type="tel" v-model="unternehmen.telefon"/></b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          Straße*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.adresse" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          Hausnummer*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.nr" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          PLZ*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.plz" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">
          Ort*:
        </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.ort" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Bundesland*: </b-col>
        <b-col lg="8" md="12">
          <DropDown :options="bundeslaender" :value="unternehmen.bundesland" @input="setBundesland"></DropDown>
        </b-col>
      </b-row>
      <b-row v-if="bezirke.length > 0">
        <b-col lg="4" md="12"> Bezirk*: </b-col>
        <b-col lg="8" md="12">
          <DropDown :options="bezirke" :value="unternehmen.bezirk" @input="setBezirk"></DropDown>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Zahlungsarten: </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.zahlungsarten" />
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12"> Liefermöglichkeiten: </b-col>
        <b-col lg="8" md="12">
          <input type="text" v-model="unternehmen.liefermoeglichkeiten" />
        </b-col>
      </b-row>
      <!-- <b-row>
      <b-col lg="4" md="12">
        Aktionen: </b-col>
      <b-col lg="8" md="12">
        <Checkbox v-model="unternehmen.gesichtsmasken">Gesichtsmasken (Mund-Nase-Masken)</Checkbox>
        <Checkbox v-model="unternehmen.ostern">Ostergeschenke</Checkbox>
       <Checkbox v-model="unternehmen.muttertag">Muttertagsgeschenke</Checkbox>
      </b-col>
    </b-row> -->
      <b-row>
        <b-col class="headline-data">
          Anmeldedaten
        </b-col>
      </b-row>
      <b-row class="text">
        <b-col>
          Mit diesen Daten wird Ihr persönliches Benutzerkonto angelegt, das Sie jederzeit bearbeiten können. Ihr persönliches Passwort wird Ihnen an die angegebene E-Mail-Adresse zugeschickt.
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="12">Email-Adresse*: </b-col>
        <b-col lg="8" md="12"><input type="email" v-model="email"/></b-col>
      </b-row>

      <b-row>
        <b-col>
          <Checkbox v-model="contact"
            >Ja, ich möchte per Telefon und/oder elektronischer Kommunikation (z. B. E-Mail, SMS) über Ihre Produkte und Services, sowie Sonder- und Werbeaktionen (z. B. Test-, Folge- und Vorteilsangebote, Veranstaltungen, Gewinnspiele, Umfragen, Bestellmöglichkeiten, Shop, Newsletter etc.) informiert werden. Ich kann diese Zustimmung jederzeit widerrufen (Kontaktdaten siehe Datenschutzinformation
            ).</Checkbox
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-right">
          <button class="btn-all" @click="createUnternehmen">Eintragen</button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-left">
          *) Pflichtfeld
        </b-col>
      </b-row>
    </b-container>

    <b-container class="data-container" v-if="success">
      <b-row class="text">
        <b-col>
          Sie erhalten in Kürze eine Email mit Ihren Zugangsdaten.
        </b-col>
      </b-row>
    </b-container>

    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import DropDown from '@/components/FormInputs/DropDown.vue';
import Checkbox from '@/components/FormInputs/Checkbox.vue';

export default {
  name: 'Register',
  components: {
    Header,
    Footer,
    DropDown,
    Checkbox,
  },
  data() {
    return {
      unternehmen: {
        firma: '',
        beschreibungprodukt: '',
        branche: 0,
        website: '',
        email: '',
        telefon: '',
        adresse: '',
        nr: '',
        plz: '',
        ort: '',
        bundesland: 0,
        bezirk: 0,
        zahlungsarten: '',
        liefermoeglichkeiten: '',
      },
      // password1: "",
      // password2: "",
      email: '',
      success: false,
      tel: '',
      contact: false,
    };
  },
  methods: {
    createUnternehmen: function() {
      if (this.unternehmen.firma == '') {
        this.$store.dispatch('addMessage', {
          message: 'Der Name Ihres Betriebes darf nicht fehlen.',
          type: 'error',
        });
        return;
      }
      if (this.unternehmen.branche == 0) {
        this.$store.dispatch('addMessage', {
          message: 'Bitte wählen Sie eine Branche.',
          type: 'error',
        });
        return;
      }
      if (this.unternehmen.adresse == '') {
        this.$store.dispatch('addMessage', {
          message: 'Die Straße Ihres Betriebes darf nicht fehlen.',
          type: 'error',
        });
        return;
      }
      if (this.unternehmen.nr == '') {
        this.$store.dispatch('addMessage', {
          message: 'Die Hausnummer Ihres Betriebes darf nicht fehlen.',
          type: 'error',
        });
        return;
      }
      if (this.unternehmen.plz == '') {
        this.$store.dispatch('addMessage', {
          message: 'Die Postleitzahl Ihres Betriebes darf nicht fehlen.',
          type: 'error',
        });
        return;
      }
      if (this.unternehmen.ort == '') {
        this.$store.dispatch('addMessage', {
          message: 'Der Ort Ihres Betriebes darf nicht fehlen.',
          type: 'error',
        });
        return;
      }

      if (this.unternehmen.bundesland == 0) {
        this.$store.dispatch('addMessage', {
          message: 'Bitte wählen Sie ein Bundesland.',
          type: 'error',
        });
        return;
      }
      if (this.unternehmen.bezirk == 0 && this.bezirke.length > 0) {
        this.$store.dispatch('addMessage', {
          message: 'Bitte wählen Sie einen Bezirk.',
          type: 'error',
        });
        return;
      }
      if (!this.validateEmail(this.email)) {
        this.$store.dispatch('addMessage', {
          message: `'${this.email}' ist keine gültige Email-Adresse.`,
          type: 'error',
        });
        return;
      }
      this.$store
        .dispatch('createUser', {
          unternehmen: this.unternehmen,
          user: {
            email: this.email,
            tel: this.tel,
            contact: this.contact,
          },
        })
        .then(
          function(results) {
            if (results.data.message.success) {
              this.success = true;
            } else {
              this.$store.dispatch('addMessage', {
                message: results.data.message.message,
                type: 'error',
              });
            }
          }.bind(this)
        );
    },
    validateEmail: function(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    imagepath: function(image) {
      return `${this.$store.state.imagedir}${image}`;
    },
    setBranche: function(value) {
      this.unternehmen.branche = value;
    },
    setBundesland: function(value) {
      this.unternehmen.bezirk = 0;
      this.unternehmen.bundesland = value;
    },
    setBezirk: function(value) {
      this.unternehmen.bezirk = value;
    },
  },
  computed: {
    branchen: function() {
      return this.$store.getters.allBranchen;
    },
    bundeslaender: function() {
      return this.$store.getters.allBundeslaender;
    },
    bezirke: function() {
      return this.$store.getters.getBezirkeForBundesland(this.unternehmen.bundesland);
    },
  },
};
</script>
